export const events = [
  {
    id: 1,
    title: 'Community Scam Awareness Workshop',
    date: '2026-02-15',
    time: '10:00 AM - 12:00 PM',
    description: 'Join us for an interactive workshop on recognizing and avoiding common phone and internet scams. Free for all community members.',
    type: 'community',
    location: 'Tacloban City Community Center',
  },
  {
    id: 2,
    title: 'Philippines Education Partnership Summit',
    date: '2026-02-28',
    time: '9:00 AM - 4:00 PM',
    description: 'Annual summit bringing together educators, nonprofits, and community leaders to discuss educational opportunities in the Philippines.',
    type: 'conference',
    location: 'Virtual Event',
  },
  {
    id: 3,
    title: 'NoMoreScamCalls App Launch',
    date: '2026-03-10',
    time: '2:00 PM PST',
    description: 'Official launch of our mobile application that helps identify and block scam calls. Live demo and Q&A session.',
    type: 'launch',
    location: 'Online Webinar',
  },
  {
    id: 4,
    title: 'Scholarship Application Deadline',
    date: '2026-03-31',
    time: '11:59 PM',
    description: 'Last day to submit applications for the 2026-2027 educational scholarship program for Filipino students.',
    type: 'deadline',
    location: 'Online',
  },
  {
    id: 5,
    title: 'Digital Safety for Seniors Webinar',
    date: '2026-04-05',
    time: '3:00 PM - 4:30 PM',
    description: 'Special webinar focused on helping seniors navigate the digital world safely and recognize common fraud tactics.',
    type: 'webinar',
    location: 'Virtual Event',
  },
  {
    id: 6,
    title: 'Graduation Celebration 2026',
    date: '2026-05-20',
    time: '6:00 PM',
    description: 'Celebrating our scholarship recipients who are graduating this year. Join us to honor their achievements!',
    type: 'celebration',
    location: 'Tacloban City',
  },
];

export const getEventsByType = (type) => {
  return events.filter(event => event.type === type);
};

export const getUpcomingEvents = () => {
  const now = new Date();
  return events.filter(event => new Date(event.date) >= now).sort((a, b) => new Date(a.date) - new Date(b.date));
};
